import React from 'react';
import { doctorDisplayModel } from '@/features/enterprise/helpers';
import Signature from '../../components/Signature';
import { ReactPDFStyle } from '../../components/DocumentPanel';

// import { Container } from './styles';

const SignaturePractitioner: React.FC<{
  encounter?: fhir4.Encounter | null;
  style?: ReactPDFStyle;
}> = ({ encounter, style = {} }) => {
  const legend = React.useMemo(() => {
    if (encounter) {
      const { name } = doctorDisplayModel(encounter);

      return name;
    }

    return 'Profissional responsável';
  }, [encounter]);

  return <Signature legend={legend} style={style} />;
};

export default SignaturePractitioner;
